"use client";

import BackButton from "@/Components/Common/Buttons/BackButton";

export default function ProductError({ error, reset }) {
  return (
    <div className="flex w-full flex-col p-3 sm:p-5">
      <BackButton />
      <div className="mt-2 bg-white p-6 rounded-lg text-center">
        <div className="text-[#4B4B4B] text-base font-medium font-poppins">
          Something went wrong loading this product
        </div>
        <p className="text-[#8E8E8E] text-sm mt-1">
          {error?.message || "An unexpected error occurred."}
        </p>
        <button
          onClick={() => reset()}
          className="mt-4 px-6 py-2 bg-[#354EF0] text-white text-sm font-medium rounded-lg"
        >
          Try again
        </button>
      </div>
    </div>
  );
}
